import Secao from "../models/secao";
import { get } from "../utils/ApiUtil";

export const fetchSecoesAsync = async () => get<Array<Secao>>("Secao")